module.exports = __webpack_public_path__ + "img/boar.224129df.jpg";